module.exports = __webpack_public_path__ + "static/media/jack_of_spades.a1f0114e.svg";